// Configuration for open source contributions
// Just paste the GitHub PR search URL from your merged PRs

export const openSourceContributions = [
  {
    url: "https://github.com/nodejs/undici/pulls?q=is%3Apr+is%3Amerged+author%3AFelixVaughan",
    bgcolor: "rgba(255, 255, 255, 0.7)",
    id: "os1",
  },
  {
    url: "https://github.com/FasterXML/jackson-databind/pulls?q=is%3Apr+is%3Amerged+author%3AFelixVaughan01",
    bgcolor: "rgba(255, 255, 255, 0.75)",
    id: "os2",
  },
  // Add more repositories here as needed
  // Just copy the URL from GitHub's PR search page
  // Example:
  // {
  //   url: "https://github.com/facebook/react/pulls?q=is%3Apr+is%3Amerged+author%3AYourUsername",
  //   bgcolor: "rgba(255, 255, 255, 0.7)",
  //   id: "os3",
  // },
];

